/**
 * GENERATED by scripts/heart-signal-points.mjs from HEALTH_SIGNAL_PATH in
 * cv-health-view.ts; do not edit by hand. Run from the repo root:
 *   node packages/utils/scripts/heart-signal-points.mjs
 *
 * The Health heart's signal line resampled into 80 points at equal arc
 * length (the design samples the same path with getPointAtLength), on the
 * `-2 -3 44 44` viewBox. The editor launcher moves these points as a wave.
 */

/** Length of the signal line in viewBox units (400 chords per cubic). */
export const HEALTH_HEART_SIGNAL_PATH_LENGTH = 44.3685;

export const HEALTH_HEART_SIGNAL_POINTS: readonly (readonly [number, number])[] = [
  [6.600, 17.000],
  [7.162, 17.000],
  [7.723, 17.000],
  [8.285, 17.000],
  [8.847, 17.000],
  [9.408, 17.000],
  [9.970, 17.000],
  [10.531, 17.000],
  [11.093, 17.000],
  [11.655, 17.000],
  [12.214, 16.973],
  [12.697, 16.697],
  [13.073, 16.281],
  [13.417, 15.837],
  [13.811, 15.439],
  [14.336, 15.334],
  [14.677, 15.769],
  [14.882, 16.291],
  [15.049, 16.828],
  [15.209, 17.366],
  [15.385, 17.899],
  [15.619, 18.409],
  [16.061, 18.697],
  [16.543, 18.429],
  [16.897, 17.995],
  [17.226, 17.539],
  [17.614, 17.137],
  [18.135, 16.951],
  [18.429, 16.480],
  [18.607, 15.948],
  [18.750, 15.405],
  [18.880, 14.858],
  [19.006, 14.311],
  [19.136, 13.765],
  [19.280, 13.222],
  [19.455, 12.688],
  [19.708, 12.189],
  [20.163, 12.104],
  [20.384, 12.618],
  [20.517, 13.163],
  [20.621, 13.715],
  [20.709, 14.270],
  [20.788, 14.826],
  [20.861, 15.383],
  [20.931, 15.940],
  [21.000, 16.497],
  [21.068, 17.055],
  [21.138, 17.612],
  [21.211, 18.169],
  [21.290, 18.725],
  [21.378, 19.280],
  [21.482, 19.832],
  [21.614, 20.377],
  [21.833, 20.892],
  [22.304, 20.837],
  [22.588, 20.355],
  [22.786, 19.830],
  [22.952, 19.293],
  [23.108, 18.754],
  [23.269, 18.215],
  [23.452, 17.685],
  [23.709, 17.187],
  [24.200, 16.969],
  [24.644, 16.637],
  [24.981, 16.188],
  [25.352, 15.769],
  [25.873, 15.604],
  [26.381, 15.828],
  [26.800, 16.201],
  [27.202, 16.593],
  [27.658, 16.918],
  [28.207, 17.000],
  [28.769, 17.000],
  [29.330, 17.000],
  [29.892, 17.000],
  [30.453, 17.000],
  [31.015, 17.000],
  [31.577, 17.000],
  [32.138, 17.000],
  [32.700, 17.000],
];
